export default __webpack_public_path__ + "static/media/supportive_care.c614812d.png";